import { useId, type ReactElement, cloneElement } from 'react';
import { cn } from '@/shared/lib/cn';

export interface FieldProps {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  className?: string;
  /** Classes extras para o rótulo (ex.: tipografia específica de uma tela). */
  labelClassName?: string;
  children: ReactElement<{ id?: string; invalid?: boolean; 'aria-describedby'?: string }>;
}

export function Field({ label, hint, error, required, className, labelClassName, children }: FieldProps) {
  const id = useId();
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={id} className={cn('text-sm font-medium text-ink-secondary', labelClassName)}>
        {label}
        {required && <span className="ml-0.5 text-danger">*</span>}
      </label>

      {cloneElement(children, {
        id,
        invalid: error ? true : undefined,
        'aria-describedby': describedBy,
      })}

      {hint && !error && (
        <p id={`${id}-hint`} className="text-xs text-ink-muted">
          {hint}
        </p>
      )}
      {error && (
        <p id={`${id}-error`} className="text-xs text-danger">
          {error}
        </p>
      )}
    </div>
  );
}
